import React, { useState } from 'react';

import BuildingModelForm from '../forms/BuildingModelForm';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogBody,
  DialogFooter,
} from '../../../../../components/ui/Dialog';
import { Button } from '../../../../../components/ui/Button';

const PhaseModal = ({ visible, onClose, submitForm, formProps, title }) => {
  const [submit, setSubmit] = useState(false);

  const formSubmit = (id, values) => {
    setSubmit(false);
    submitForm(id, values);
  };

  return (
    <Dialog open={visible} onOpenChange={onClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>
        <DialogBody>
          <BuildingModelForm formProps={formProps} submit={formSubmit} submitOutside={submit} />
        </DialogBody>
        <DialogFooter>
          <Button
            key={1}
            variant="outline"
            data-testid="building-model-modal-close-btn"
            onClick={() => onClose()}
          >
            Zavřít
          </Button>
          <Button
            key={2}
            data-testid="building-model-modal-submit-btn"
            onClick={() => setSubmit(true)}
          >
            Potvrdit
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default PhaseModal;
